import React, { useState, useEffect } from 'react';
import './CheckboxStylized.css';

export function CheckBoxStylized({ name, checked, onChange, disabled }) {

    const [isChecked, setIsChecked] = useState(checked);

    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);

    const handleOptionSelect = () => {
        if (!disabled) {
            const newChecked = !isChecked;
            setIsChecked(!isChecked);
            onChange({
                target: {
                    name: name, 
                    checked: newChecked,
                    type: 'checkboxStylized'
                }
            });
        }
    };

    return (
        <div
            className={`optionItem ${isChecked ? "select" : ""} ${disabled ? "disabled" : ""}`}
            onClick={handleOptionSelect}
        >
            <div className={`customCheckBoxStylized ${isChecked ? "checked" : ""}`}>
                {isChecked &&
                    <i className="fas fa-check" style={{ color: '#FFFFFF', fontSize: '14px' }}></i>}
            </div>
        </div>
    );
}